import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalNotificationService } from '../../modules/listas/services/modal-notification.service';
import { BcIconModule } from '@bancolombia/design-system-web/bc-icon';
import { CommonModule } from '@angular/common';
import { BcButtonModule } from '@bancolombia/design-system-web/bc-button';

@Component({
    selector: 'app-general-modal',
    imports: [CommonModule, BcIconModule, BcButtonModule],
    templateUrl: './general-modal.component.html',
    styleUrl: './general-modal.component.scss'
})
export class GeneralModalComponent {

  @Output() enviarDatos = new EventEmitter<boolean>();
  modalDatos: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private modalNotificationService: ModalNotificationService,

  ) { this.modalDatos = data; }


  close() {
    this.modalNotificationService.closeModal();
  }

  denegar() {
    this.enviarDatos.emit(false);
    this.modalNotificationService.closeModal();
  }

  aceptar() {

    this.enviarDatos.emit(true);
    this.modalNotificationService.closeModal();
  }
}
